import { roofStoreyKey } from '@editorStores'

/** UI label of a storey id: `EG`, `n. OG`, `n. UG` (negative ids) or `Dach`. */
export const storeyToLabel = (storey: string) => {
  if (storey === '0') return 'EG'
  if (storey === roofStoreyKey) return 'Dach'
  // Same as the backend's `storeyIdxToLabel`, e.g. for plan names.
  if (storey.startsWith('-')) return `${storey.slice(1)}. UG`
  return `${storey}. OG`
}
